import {omit} from '@coolcolduk/util';
import type {Todo} from '@cp/model';
import type {WithFieldValue} from 'firebase/firestore';
import {serverTimestamp, updateDoc} from 'firebase/firestore';
import getTodoDocRef from './getTodoDocRef';

export default async function updateTodoDoc(
  uid: string,
  todoId: string,
  data: WithFieldValue<Partial<Todo>>,
): Promise<void> {
  const stripped = omit(data, ['id', 'createdAt', 'updatedAt']);
  const ref = getTodoDocRef(uid, todoId);
  if (Object.keys(stripped).length === 0) return;
  await updateDoc(ref, {updatedAt: serverTimestamp(), ...stripped});
}
